<template>
    <div class="box-icon">
        <template v-if="!isBank">
            <el-dropdown @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
                <span class="el-dropdown-link">
                <el-tooltip content="收藏到题库" placement="top" effect="light">
                    <i v-if="question.isedit && !question.bqid"   class="el-icon-star-off"></i>
                </el-tooltip>
                </span>
                <el-dropdown-menu slot="dropdown">
                <div class="scroll-body" style="overflow-y: auto;" :style="{maxHeight: isAddBank ? '102px' : '200px'}">
                    <el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
                    <span>{{item.name}}</span>
                    <el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item 
                    disabled
                    style="
                        font-size: 12px;
                        color: #ccc"
                    class="dropdown-item" 
                    v-if="bankList.length == 0">
                    <span>暂无题库</span>
                    </el-dropdown-item>
                </div>

                <el-dropdown-item v-if="isAddBank" divided style="text-align:center">
                    <el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
                    <el-form-item
                        prop="name"
                        :rules="[
                        { required: true, message: '不能为空'},
                        ]"
                    >
                        <el-input size="mini" v-model="bankForm.name"></el-input>
                    </el-form-item>
                    <el-form-item  size="mini" style="text-align: right;margin-bottom: 0;">
                        <el-button type="text" @click="addBank">创建</el-button>
                        <el-button  type="text" @click="cancelAddBank">取消</el-button>
                    </el-form-item>
                    </el-form>
                </el-dropdown-item>
                    
                <el-dropdown-item divided style="text-align:center">
                    <el-button  @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
                </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-tooltip content="取消收藏" placement="top" effect="light">
                <i v-if="question.isedit && question.bqid"  class="el-icon-star-on" @click="delFormBank"></i>
            </el-tooltip>
        </template>

        <template v-if="!isBankViewTest">
            <el-tooltip content="拖动题目" placement="top" effect="light">
                <i class="el-icon-rank handle"></i>
            </el-tooltip>
            
            <el-tooltip content="复制题目" placement="top" effect="light">
                <i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyQuestion"></i>
            </el-tooltip>
            
            <el-tooltip content="删除题目" placement="top" effect="light">
                <i v-if="question.isedit" class="el-icon-delete" @click="delQuestion" ></i>
            </el-tooltip>
        </template>
    </div>
</template>

<script>
export default {
    // 试题操作：收藏到题库、逻辑、移动、复制、删除
    name: 'OperateWrap',
    data() {
        return {
            isAddBank: false,
            bankForm: {
                isSystemBank: 0, // 我的题库
                name: '',
                type: '未分类'
            }
        }
    },
    props: {
        question: {},
        bankId: { type: String, default: '' },
        bankList: {
            type: Array,
            default: () => {
                return []
            }
        },
		isBankViewTest: {
			type: Boolean,
			default: false
		},
        // 题库编辑试题，不能显示是否收藏按钮
        isBank: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        // IsBankViewTest() {
        //     // console.log(' this.isBankViewTest :>> ',  this.isBankViewTest);
        //     return this.isBankViewTest()
        // },
        // bankList() {
        //     return this.BankList()
        // }
    },
    created() {
        // console.log('-----------------------')
        if (this.question.bid && this.question.bqid) {
            this.getBankque()
        }
    },
    methods: {
        // 获取试题题库列表
        getBankque() {
            let that = this;
			let data = this.$qs.stringify({
				bankId: this.question.bid, // 0自建题库 1系统题库
				difficulty: '',
				pageIndex: 1,
				pageSize: 10000,
				type: '', // 题库类别
				isDel: 0, // 是否为回收站列表
				bankType: 0 // 是否为0考试 1问卷
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankQuesList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
                        console.log('that.questio :>> ', that.questio);
						let index = res.resultBody.datas.findIndex( info => info.id == that.question.bqid)
                        if (index == -1) {
                            that.question.bid = ''
                            that.question.bqid = ''
                        }
					}
				}
			};
			this.$util.request(params);
        },
		// 题库start
		getBankList(e) {
			if (e) {
				this.$emit('getBankList')
			}
		},
        addToBank(id) {
            console.log('id :>> ', id);
            this.$refs.bankDropdown.hide()
            this.$emit('addToBank', this.question, id)
        },
        cancelAddBank() {
            this.isAddBank = false
            this.bankForm.name = ''
        },
        addBank() {
            this.$refs.ValidateForm.validate((valid) => {
                if (valid) {
                    this.isAddBank = true
                    this.$emit('addBank', this.bankForm, this.question.qid)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        delFormBank() {
            this.$emit('delFormBank', this.question)
        },
        
        // 复制当前题目
        copyQuestion(){
            this.$emit('copyQuestion')
        },
        delQuestion(){
            this.$emit('delQuestion')
        }
		// 题库end
    }
} 
</script>
<style scoped lang="scss">

.box-icon i {
    font-size: 18px !important;
    line-height: 30px !important;
    margin-right: 15px;
    text-align: right;
    cursor: pointer;
}

.to-bank{
  color: #424542;
}

.scroll-body{
  max-height: 200px;
  overflow: auto;
}
.dropdown-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn{
    margin-left: 10px;
  }
}
</style>